import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import en from '../i18n/en';
import es from '../i18n/es';

const DICTS = { en, es };
const I18nCtx = createContext(null);

function getInitialLocale() {
  const saved = typeof window !== 'undefined' ? localStorage.getItem('aura.locale') : null;
  if (saved && DICTS[saved]) return saved;
  const nav = typeof navigator !== 'undefined' ? navigator.language : 'es';
  return nav?.toLowerCase().startsWith('en') ? 'en' : 'es';
}

function getIn(obj, path) {
  return path.split('.').reduce((acc, k) => (acc == null ? undefined : acc[k]), obj);
}

export function I18nProvider({ children }) {
  const [locale, setLocale] = useState(getInitialLocale);

  useEffect(() => {
    localStorage.setItem('aura.locale', locale);
    document.documentElement.lang = locale;
  }, [locale]);

  const value = useMemo(() => ({
    locale,
    setLocale,
    toggle: () => setLocale((l) => (l === 'es' ? 'en' : 'es')),
    t: (path) => getIn(DICTS[locale], path) ?? getIn(DICTS.en, path) ?? path,
  }), [locale]);

  return <I18nCtx.Provider value={value}>{children}</I18nCtx.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nCtx);
  if (!ctx) throw new Error('useI18n must be used within I18nProvider');
  return ctx;
}
